import Vue from 'vue'
import ViewUI from './plugin/iview'
import formCreate from '@form-create/iview4'
import App from './App.vue'
import router from './router'
import http from './http/http'
import fullhttp from './http/fullhttp'
import config from './config/config'
import 'view-design/dist/styles/iview.css'
import "./assets/style/reset.less"
import "./assets/style/common.less"
import md5 from 'js-md5' // MD5加密

// 需求所以引入
import "element-ui/lib/theme-chalk/index.css";
import ElementUI, { Tree } from 'element-ui';

import { statusSort, formatDate, yearformatDate } from "@utils/dataHandling";
import SearchArea from "@compoents/SearchArea.vue";
import TableArea from "@compoents/TableArea.vue";

import moment from 'moment'

Vue.use(Tree); // 日期转换
Vue.prototype.$moment = moment;
Vue.prototype.formatDate = formatDate;
Vue.prototype.yearformatDate = yearformatDate;

Vue.config.productionTip = false
/**
 * @description 全局相关注册
 */
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.use(formCreate)
Vue.use(http);
Vue.use(fullhttp);

/** 全局通用组件 */
Vue.component('SearchArea', SearchArea);
Vue.component('TableArea', TableArea);
Vue.prototype.$config = config

/** 顶部路由加载进度条 */
router.beforeEach((to, from, next) => {
  Vue.prototype.$Loading.start();
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(routers => {
  Vue.prototype.$Loading.finish();
});

Vue.filter('dateFmt', (input, formatString = "YYYY-MM-DD") => {
  // es5函数参数设置默认值
  // const lastFormatString = formatString || ''

  // moment(input) 把时间字符串转成时间对象
  // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString)
})

/** 全局mixin**/
Vue.mixin({
  methods: {
    // reset() {
    //   this.$refs["searchData"].resetFields();
    //   this.search();
    // },
    statusSort
  }
})

let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
window.userInfo = userInfo;
window.md5 = md5;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
